export enum EActionTypes {
  FILTER_CRITERIA_UPADATED = 'FILTER_CRITERIA_UPADATED',
  SORT_CRITERIA_UPADATED = 'SORT_CRITERIA_UPADATED',
  SEARCH_FETCH = 'SEARCH_FETCH',
  SEARCH_SUCCESS = 'SEARCH_SUCCESS',
  SEARCH_ERROR = 'SEARCH_ERROR',
  TABLE_PAGE_CHANGE = 'TABLE_PAGE_CHANGE',
  TABLE_PAGESIZE_CHANGE = 'TABLE_PAGESIZE_CHANGE',
  TABLE_SELECT_ITEM = 'TABLE_SELECT_ITEM',
  TABLE_TOGGLE_ITEM = 'TABLE_TOGGLE_ITEM',
  TABLE_TOGGLE_ALL = 'TABLE_TOGGLE_ALL',
  CLEAR_SELECTION = 'CLEAR_SELECTION',
  TABLE_COLUMNS_UPDATED = 'TABLE_COLUMNS_UPDATED',
}

export default EActionTypes;
